import './services.scss'
import employee from './employee.png'

function Services() {
    return (
        <div className='services'>
            <div className='services__list'>
                <ul className='menu'>
                    <li className='menu__item'>
                        <a href='/' className='link link_active'>Hosting</a>
                    </li>
                    <li className='menu__item'>
                        <a href='/' className='link'>Domain</a>
                    </li>
                    <li className='menu__item'>
                        <a href='/' className='link'>SEO</a>
                    </li>
                    <li className='menu__item'>
                        <a href='/' className='link'>Email</a>
                    </li>
                </ul>
                <div className='service'>
                    <h1 className='service__header'>Premium Web Hosting for Your Website</h1>
                    <div className='service__description'>
                        Blazing fast web hosting for individuals and
                        <br/>
                        businesses of all sizes backed by 24x7x365 Support.
                    </div>
                    <div className='service__buttons'>
                        <button className='button button_burgundy'>Create an Account</button>
                        <button className='button'>Choose your plan</button>
                    </div>
                </div>
            </div>
            <img src={employee} alt='employee' className='services__image'/>
        </div>
    )
}

export default Services
